import { render, staticRenderFns } from "./FinancialFilesPage.vue?vue&type=template&id=6cd5a864"
import script from "./FinancialFilesPage.vue?vue&type=script&lang=js"
export * from "./FinancialFilesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports